import { EPLEDGE_UNPLEDGE, EPLEDGE_UNPLEDGE_ERROR, EPLEDGE_UNPLEDGE_HIDE_ERROR, EPLEDGE_UNPLEDGE_START_LOADER, EPLEDGE_UNPLEDGE_STOP_LOADER, } from "../interface/iEdpledgeUnpledge";
const initState = {
    data: {},
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const epledgeUnpledgeReducer = (state = initState, action) => {
    switch (action.type) {
        case EPLEDGE_UNPLEDGE: {
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        }
        case EPLEDGE_UNPLEDGE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case EPLEDGE_UNPLEDGE_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case EPLEDGE_UNPLEDGE_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case EPLEDGE_UNPLEDGE_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default epledgeUnpledgeReducer;
